import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { AlertService } from 'ngx-alerts';
import { NgxSpinnerService } from 'ngx-spinner';
import { DlaService } from 'src/app/shared/dla.service';

@Component({
  selector: 'app-register2',
  templateUrl: './register2.component.html',
  styleUrls: ['./register2.component.css']
})
export class Register2Component implements OnInit {
  registerForm: FormGroup;
  submitted = false;
  year: string;
  isTeenager = false;

  constructor(private router: Router,
    private spinner: NgxSpinnerService,
    private alertService: AlertService,
    private formBuilder: FormBuilder,
    private dlaService: DlaService) {
    this.registerForm = this.formBuilder.group({
      employment_status: ['', Validators.required],
      company_name: [''],
      position_in_company: [''],
      company_address: [''],
      company_phone_number: [''],
      name_of_ministry: [''],
      religion: ['', Validators.required],
      company_email: ['', [Validators.pattern('^[a-z0-9._%+-]+@[a-z0-9.-]+.[a-z]{2,4}$')]],
      // role_id: [5],
      // gender: ['', Validators.required],
      // marital_status: ['SINGLE', Validators.required],

      // phone_number: ['', [Validators.required, Validators.minLength(10), Validators.pattern('^[0-9]*$')]],
      // password: ['', [Validators.required, Validators.minLength(6)]],
      // confirmPassword: ['', Validators.required],
      // residence_address: ['', Validators.required],
      // country: ['', Validators.required],
      // date_of_birth: ['', Validators.required]
    });
    this.loadScripts();
  }

  ngOnInit() {
    this.year = new Date().getFullYear().toString();
  }

  get f() {
    return this.registerForm.controls;
  }

  submitRegister() {
    this.submitted = true;

    if (this.registerForm.invalid) {
      return;
    }

    //console.log(this.registerForm.value);

    const tempRegisterData = JSON.parse(localStorage.getItem('tempRegisterData'));

    const allRules = Object.assign(tempRegisterData, this.registerForm.value);

    // console.log(allRules);

    //alert('SUCCESS!! :-)\n\n' + JSON.stringify(this.registerForm.value, null, 4));
    this.spinner.show();
    this.dlaService.registerUser(allRules).subscribe(
      (data: any) => {
        this.spinner.hide();
        const error: boolean = data.error;
        console.log('Register Response:', data);
        if (!error) {
          // this.alertService.success(data.message);
          // this.router.navigate(['/login']);
          // this.router.navigate(["/confirm-registration", { queryParams: {type: 'success', message: data.message}}]);
          this.router.navigateByUrl(
              `/confirm-registration?type=success&message=${data.message}`
            );
        } else {
          // this.alertService.danger(data.message);
          //  this.router.navigate(["/confirm-registration", { queryParams: {type: 'error', message: data.message}}]);
          this.router.navigateByUrl(
              `/confirm-registration?type=error&message=${data.message}`
            );
        }
      },
      error => {
        this.spinner.hide();
        // this.alertService.danger('An error occurred, Please try again');
        // this.router.navigate(["/confirm-registration", { queryParams: {type: 'error', message: "An error occurred, Please try again"}}]);
         this.router.navigateByUrl(
            `/confirm-registration?type=error&message=An error occurred, Please try again`
          );
      }
    );
  }

  loadScripts() {
    const dynamicScripts = [
      'assets/js/vendor/jquery-1.11.3.min.js',
      'assets/js/bootstrap.min.js',
      'assets/js/wow.min.js',
      'assets/js/jquery-price-slider.js',
      'assets/js/jquery.meanmenu.js',
      'assets/js/owl.carousel.min.js',
      'assets/js/jquery.sticky.js',
      'assets/js/jquery.scrollUp.min.js',
      'assets/js/scrollbar/jquery.mCustomScrollbar.concat.min.js',
      'assets/js/scrollbar/mCustomScrollbar-active.js',
      'assets/js/metisMenu/metisMenu.min.js',
      'assets/js/metisMenu/metisMenu-active.js',
      'assets/js/tab.js',
      'assets/js/icheck/icheck.min.js',
      'assets/js/icheck/icheck-active.js',
      'assets/js/plugins.js',
      'assets/js/main.js'
    ];
    // tslint:disable-next-line:prefer-for-of
    for (let i = 0; i < dynamicScripts.length; i++) {
      const node = document.createElement('script');
      node.src = dynamicScripts[i];
      node.type = 'text/javascript';
      node.async = false;
      node.charset = 'utf-8';
      document.getElementsByTagName('head')[0].appendChild(node);
    }
  }
}
